import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h6 q-py-md q-px-md"
}
const _hoisted_2 = {
  key: 2,
  class: "q-px-md q-py-md"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_5 = {
  key: 0,
  class: "col-6 q-pr-sm"
}
const _hoisted_6 = {
  key: 1,
  class: "col-6 q-pl-md"
}
const _hoisted_7 = {
  key: 2,
  class: "q-pt-md"
}
const _hoisted_8 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_9 = {
  key: 3,
  class: "q-pt-md"
}
const _hoisted_10 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_11 = {
  key: 4,
  class: "q-pt-md"
}
const _hoisted_12 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_13 = {
  key: 5,
  class: "q-pt-md"
}
const _hoisted_14 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_15 = { class: "q-pb-xs text-overline text-dark text-uppercase" }
const _hoisted_16 = {
  key: 7,
  class: "q-pt-md"
}
const _hoisted_17 = { class: "text-overline text-uppercase text-dark" }

import { PropType, watch, ref, onMounted, computed } from "vue";
  import { QInput, QSelect } from "quasar";
  
  import { useAge, useCurrencyFormatter } from "src/functions";

  import { Customer, LoanApplication } from "src/types/loan-application/index";
  import { DrivingLicence_Enum } from "src/types/enums/index";
  import { DrivingLicenceOptions, MaritalStatusOptions, TitleOptions } from "src/const/select-options"
  import DataTable from "./DataTable.vue";
  import TitleSelect from "src/components/form/inputs/TitleSelect.vue";
  import DrivingLicenceSelect from "src/components/form/inputs/DrivingLicenceSelect.vue";
  import MaritalStatusSelect from "src/components/form/inputs/MaritalStatusSelect.vue";
  import MobileNumberInput from "src/components/form/inputs/MobileNumberInput.vue";
  import EmailInput from "src/components/form/inputs/EmailInput.vue";
  import DobInput from "src/components/form/inputs/DobInput.vue";
  import CurrencyInput from "src/components/form/inputs/CurrencyInput.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDetailsForm',
  props: {
    modelValue: {
      type: Object as PropType<Customer>,
      default: {} as Customer
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    title: {
      type: Boolean,
      default: false
    },
    firstName: {
      type: Boolean,
      default: true
    },
    surname: {
      type: Boolean,
      default: true
    },
    titleRequired: {
      type: Boolean,
      default: false
    },
    dob: {
      type: Boolean,
      default: false
    },
    dobRequired: {
      type: Boolean,
      default: false
    },
    maritalStatus: {
      type: Boolean,
      default: false
    },
    maritalStatusRequired: {
      type: Boolean,
      default: false
    },
    drivingLicence: {
      type: Boolean,
      default: false
    },
    drivingLicenceRequired: {
      type: Boolean,
      default: false
    },
    monthlyIncome: {
      type: Boolean,
      default: false
    },
    monthlyIncomeRequired: {
      type: Boolean,
      default: false
    },
    email: {
      type: Boolean,
      default: false
    },
    emailRequired: {
      type: Boolean,
      default: false
    },
    mobileNumber: {
      type: Boolean,
      default: false
    },
    mobileNumberRequired: {
      type: Boolean,
      default: false
    },
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<Customer>({
    get() {
      return props.modelValue 
    },
    set(value: Customer) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  watch(() => value.value.firstName, () => {
    if (value.value.firstName && value.value.firstName !== '') {
      value.value.firstName = value.value.firstName.split("")[0].toUpperCase() + value.value.firstName.substr(1);
    }
  })
  watch(() => value.value.lastName, () => {
    if (value.value.lastName && value.value.lastName !== '') {
      value.value.lastName = value.value.lastName.split("")[0].toUpperCase() + value.value.lastName.substr(1);
    }
  })

  const titleSelect = ref<QSelect | null>(null);
  const firstNameInput = ref<QInput | null>(null);
  const lastNameInput = ref<QInput | null>(null);
  const dobInput = ref<QInput | null>(null);
  const maritalSelect = ref<QSelect | null>(null);
  const drivingLicenceSelect = ref<QSelect | null>(null);
  const incomeInput = ref<QInput | null>(null);
  const emailInput = ref<QInput | null>(null);
  const numberInput = ref<QInput | null>(null);

  const showDate = ref(false);

  __expose({ validate })
  function validate() {
    let valid = true;

    firstNameInput.value!.validate() ? null : valid = false;
    lastNameInput.value!.validate() ? null : valid = false;

    props.titleRequired ? titleSelect.value!.validate() ? null : valid = false : null;
    props.dobRequired ? dobInput.value!.validate() ? null : valid = false : null;
    props.titleRequired ? maritalSelect.value!.validate() ? null : valid = false : null;
    props.maritalStatusRequired ? drivingLicenceSelect.value!.validate() ? null : valid = false : null;
    props.monthlyIncomeRequired ? incomeInput.value!.validate() ? null : valid = false : null;
    props.emailRequired ? emailInput.value!.validate() ? null : valid = false : null;
    props.mobileNumberRequired ? numberInput.value!.validate() ? null : valid = false : null;

    return valid
  }

  const dataTableData = computed(() => {
    return [
      { label: "Name", value: (value.value.title ? TitleOptions.find(t => t.value === value.value.title)!.label + " " : "") + value.value.firstName + " " + value.value.lastName },
      { label: "D.O.B", value: value.value.dateOfBirth ? new Date(value.value.dateOfBirth).toLocaleDateString("en-GB") : "" },
      { label: "Marital Status", value: value.value.maritalStatus ? MaritalStatusOptions.find(s => s.value === value.value.maritalStatus)!.label + " " : "" },
      { label: "Driving Licence Type", value: DrivingLicence_Enum[value.value.drivingLicenceType]},
      { label: "Net Monthly Income", value: value.value.netMonthlyIncome ? useCurrencyFormatter(value.value.netMonthlyIncome!) : "" },
      { label: "Email", value: value.value.email },
      { label: "Contact No.", value: value.value.contactNumber },
    ]
  })

  

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Customer Details"))
      : _createCommentVNode("", true),
    (__props.showTitle)
      ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(TitleSelect, {
                  modelValue: value.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.title) = $event)),
                  ref_key: "titleSelect",
                  ref: titleSelect,
                  required: __props.titleRequired
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, "Title " + _toDisplayString(__props.titleRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ]))
            : _createCommentVNode("", true),
          (__props.firstName || __props.surname)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["row", __props.showTitle? 'q-pt-md' : ''])
              }, [
                (__props.firstName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "First Name *", -1)),
                      _createVNode(_unref(QInput), {
                        modelValue: value.value.firstName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.firstName) = $event)),
                        dense: "",
                        "data-cy": "firstNameInput",
                        ref_key: "firstNameInput",
                        ref: firstNameInput,
                        rules: [val => !!val || 'Required'],
                        outlined: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]))
                  : _createCommentVNode("", true),
                (__props.surname)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Last Name *", -1)),
                      _createVNode(_unref(QInput), {
                        modelValue: value.value.lastName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.lastName) = $event)),
                        dense: "",
                        "data-cy": "lastNameInput",
                        ref_key: "lastNameInput",
                        ref: lastNameInput,
                        rules: [val => !!val || 'Required'],
                        outlined: ""
                      }, null, 8, ["modelValue", "rules"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (__props.dob)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(DobInput, {
                  modelValue: value.value.dateOfBirth,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value.value.dateOfBirth) = $event)),
                  required: __props.dobRequired,
                  ref_key: "dobInput",
                  ref: dobInput
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, "D.O.B (dd/mm/yyyy) " + _toDisplayString(__props.dobRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ]))
            : _createCommentVNode("", true),
          (__props.maritalStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(MaritalStatusSelect, {
                  modelValue: value.value.maritalStatus,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((value.value.maritalStatus) = $event)),
                  ref_key: "maritalSelect",
                  ref: maritalSelect,
                  required: __props.maritalStatusRequired
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, "Marital Status " + _toDisplayString(__props.maritalStatusRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ]))
            : _createCommentVNode("", true),
          (__props.drivingLicence)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(DrivingLicenceSelect, {
                  modelValue: value.value.drivingLicenceType,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((value.value.drivingLicenceType) = $event)),
                  ref_key: "drivingLicenceSelect",
                  ref: drivingLicenceSelect,
                  required: __props.drivingLicenceRequired
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, "Driving Licence Type " + _toDisplayString(__props.drivingLicenceRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ]))
            : _createCommentVNode("", true),
          (__props.monthlyIncome)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(CurrencyInput, {
                  modelValue: value.value.netMonthlyIncome,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((value.value.netMonthlyIncome) = $event)),
                  ref_key: "incomeInput",
                  ref: incomeInput,
                  required: __props.monthlyIncomeRequired
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, "Net Monthly Income " + _toDisplayString(__props.monthlyIncomeRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ]))
            : _createCommentVNode("", true),
          (__props.email)
            ? (_openBlock(), _createElementBlock("div", {
                key: 6,
                class: _normalizeClass(__props.firstName || __props.surname ? 'q-pt-md' : '')
              }, [
                _createVNode(EmailInput, {
                  modelValue: value.value.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((value.value.email) = $event)),
                  ref_key: "emailInput",
                  ref: emailInput,
                  required: __props.emailRequired
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, "Email " + _toDisplayString(__props.emailRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ], 2))
            : _createCommentVNode("", true),
          (__props.mobileNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(MobileNumberInput, {
                  modelValue: value.value.contactNumber,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((value.value.contactNumber) = $event)),
                  ref_key: "numberInput",
                  ref: numberInput,
                  required: __props.mobileNumberRequired
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, "Mobile No. " + _toDisplayString(__props.mobileNumberRequired ? '*' : ''), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "required"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(DataTable, {
          key: 3,
          data: dataTableData.value
        }, null, 8, ["data"]))
  ], 64))
}
}

})